module.exports = __webpack_public_path__ + "img/collection-memoireRingsRosegold@2x.0f486cc.webp";